export enum IFRAME_MESSAGES {
  INSIDE_BUSINESS_HOURS = 'INSIDE_BUSINESS_HOURS',
  OUTSIDE_BUSINESS_HOURS = 'OUTSIDE_BUSINESS_HOURS',
}
